import React from "react";
import {
  Dialog,
  Checkbox,
  TextField,
  FlatButton,
  RaisedButton,
  RadioButtonGroup,
  RadioButton
} from "material-ui";
import { Creatable } from "react-select";
import moment from "moment";
import qs from "qs";
import uniq from "lodash/uniq";

import config from "../config";

import connectToStores from "alt-utils/lib/connectToStores";
import PassBucketActions from "../actions/PassBucketActions";
import PassBucketStore from "../stores/PassBucketStore";
import PassStore from "../stores/PassStore";
import PassActions from "../actions/PassActions";
import UserStore from "../stores/UserStore";
import EventBucketStore from "../stores/EventBucketStore";
import EventBucketActions from "../actions/EventBucketActions";

import InfoNotice from "./partials/info-notice.jsx";

import InjectedSelect from "./partials/injected-select.jsx";
import Label from "./partials/label.jsx";
import LinkLike from "./partials/link-like.jsx";
import DateTimeField from "./partials/datetime-field.jsx";
import SelectField from "./partials/select-field.jsx";
import QuantityEditor from "./partials/quantity-editor.jsx";
import WorkingIndicator from "./partials/working-indicator.jsx";

const DEFAULT_FIELDS = [{ value: "name", label: "Name" }];

const CUSTOM_TEXT_PREFIX = "custom|";

class PassLabelPrinter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPasses: null,
      skip: null,
      selectedPassBuckets: [],
      selectedMemberships: [],
      passBucketConfiguration: {},
      shownConfigs: {},
      hasInjectedSavedSettings: false,
      settings: {},
      printAllTime: true,
      startTime: moment().startOf("day").toDate(),
      endTime: null,

      printing: false,
      showPrintSuccess: false,
      completedPrint: null,
      isMembership: null,
    };

    this.setPassBuckets = this.setPassBuckets.bind(this);
    this.updateConfig = this.updateConfig.bind(this);
    this.getPDFUrl = this.getPDFUrl.bind(this);
    this.print = this.print.bind(this);
    this.closePrint = this.closePrint.bind(this);
  }

  static getStores() {
    return [PassBucketStore, PassStore, EventBucketStore, UserStore];
  }

  static getPropsFromStores() {
    let state = PassBucketStore.getState();
    state.apiKey = UserStore.getState().apiKey;
    return state;
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  setPassBuckets(items, persist = true) {
    const filteredItems = items.filter(i => i.is_membership === this.state.isMembership)
    let config = {};

    filteredItems.forEach(b => {
      config[b.id] = b.label_printer_config || {};
      if (!config[b.id].rows || !config[b.id].rows.length) {
        config[b.id].rows = [{ fields: ["name"] }];
      }
    });

    this.setState({
      selectedPassBuckets: this.state.isMembership ? [] : filteredItems,
      selectedMemberships: this.state.isMembership ? filteredItems : [],
      passBucketConfiguration: config
    });

    // Persist
    if (persist) {
      this.updateSetting(
        "selected_pass_buckets",
        filteredItems.map(b => b.id)
      );
    }
  }

  updateConfig(id, config) {
    let passBucketConfiguration = Object.assign(
      {},
      this.state.passBucketConfiguration
    );
    passBucketConfiguration[id] = config;
    this.setState({ passBucketConfiguration });

    // Persist
    PassBucketActions.edit(id, {
      label_printer_config: config
    });
  }

  updateSetting(key, value) {
    let settings = Object.assign({}, this.state.settings);
    settings[key] = value;
    this.setState({ settings });

    // Persist
    EventBucketActions.edit(this.props.params.eventBucketId, {
      label_printer_config: settings
    });
  }

  getPDFUrl(opts = {}) {
    let { apiKey } = this.props;

    if (opts.id && !Array.isArray(opts.id)) {
      opts.id = [opts.id];
    }

    const items = this.state.isMembership ? this.state.selectedMemberships : this.state.selectedPassBuckets

    let conditions = {
      _id:
        (Array.isArray(opts.id) ? { $in: opts.id } : null) ||
        (this.state.selectedPasses && {
          $in: this.state.selectedPasses.map(p => p.id)
        }) ||
        undefined,
      pass_bucket:
        !this.state.selectedPasses && items.length
          ? items.map(b => b.id)
          : undefined,
      updated_at:
        !this.state.printAllTime &&
          (this.state.startTime || this.state.endTime)
          ? {
            $gte: this.state.startTime
              ? this.state.startTime.toISOString()
              : undefined,
            $lte: this.state.endTime
              ? this.state.endTime.toISOString()
              : undefined
          }
          : undefined
    },
      query = {
        api_key: apiKey,
        god_become_user: UserStore.isGod()
          ? UserStore.getGodCredentials().activeUser
          : undefined,
        conditions: JSON.stringify(conditions),
        skip: opts.skip || this.state.skip || undefined
      };

    return `${config.endpoint}passes/labels${opts.directPdf ? ".pdf" : ""}?${qs.stringify(query)}`;
  }

  print() {
    this.setState({ printing: true });
    fetch(this.getPDFUrl())
      .then(r => r.json())
      .then(d => {
        if (d.error || !d.temporary_export) {
          this.setState({
            printing: false,
            showPrintSuccess: true,
            completedPrint: {
              error: d.error ? d.error.message : "An unknown error occurred"
            }
          });
        } else {
          this._checkInterval = setInterval(() => {
            fetch(
              `${config.endpoint}temporary_exports/${d.temporary_export
              }?${UserStore.makeApiKeyQueryString()}`
            )
              .then(r => r.json())
              .then(e => {
                if (e.completed_at) {
                  clearInterval(this._checkInterval);
                  this.setState({
                    printing: false,
                    showPrintSuccess: true,
                    completedPrint: e
                  });
                  if (e.download_url) {
                    window.open(e.download_url);
                  }
                }
              });
          }, 1000);
        }
      });
  }

  closePrint() {
    this.setState({
      printing: false,
      showPrintSuccess: false,
      completedPrint: null
    });
    clearInterval(this._checkInterval);
  }

  componentDidMount() {
    const isMembership = this.props.location.pathname.includes("membership");
    this.setState({ isMembership: isMembership })

    if (this.props.location.query.quick) {
      let win = window.open(
        this.getPDFUrl({
          id: this.props.location.query.pass,
          skip: this.props.location.query.skip,
          directPdf: true
        }),
        "eventive-quick-labels"
      );
      // Disabled: see intercom https://app.intercom.io/a/apps/oj5vkp3b/inbox/inbox/all/conversations/21510974050
      // if (win) { win.print(); }
      this.context.router.goBack();
      return;
    }

    if (this.props.location.query.pass) {
      let passes = this.props.location.query.pass;
      if (!Array.isArray(passes)) {
        passes = [passes];
      }
      passes.forEach(p => PassActions.fetchOne(p));
    }

    PassBucketActions.fetchAllForEventBucket(this.props.params.eventBucketId);
  }

  componentWillReceiveProps(newProps) {
    let bucket = EventBucketStore.getEventBucketById(
      newProps.params.eventBucketId
    ),
      passIds =
        newProps.location.query.pass &&
        (Array.isArray(newProps.location.query.pass)
          ? newProps.location.query.pass
          : [newProps.location.query.pass]),
      readyToInject =
        !!bucket &&
        (!bucket.label_printer_config.selected_pass_buckets.length ||
          Object.keys(newProps.passBuckets).length) &&
        (!newProps.location.query.pass ||
          passIds.every(id => PassStore.getPassById(id)));

    if (readyToInject && !this.state.hasInjectedSavedSettings) {
      this.setState(
        {
          hasInjectedSavedSettings: true,
          settings: bucket.label_printer_config
        },
        () => {
          setTimeout(() => {
            if (passIds) {
              let selectedPasses = passIds.map(p => PassStore.getPassById(p));
              this.setState({
                selectedPasses: selectedPasses,
                skip: this.props.location.query.skip
              });
              let passBucketIds = uniq(
                selectedPasses.map(p => p.pass_bucket.id)
              );
              this.setPassBuckets(
                passBucketIds.map(id => PassBucketStore.getPassBucketById(id)),
                /* persist */ false
              );
            } else if (!this.state.selectedPassBuckets.length && !this.state.selectedMemberships.length) {
              this.setPassBuckets(
                bucket.label_printer_config.selected_pass_buckets.map(id =>
                  PassBucketStore.getPassBucketById(id)
                ),
                /* persist */ false
              );
            }
          }, 0);
        }
      );
    }
  }

  getStyles() {
    return {
      selectedPass: {
        border: "1px solid #ccc",
        padding: 10
      },
      h2: {
        marginTop: "1em",
        marginBottom: 0
      },
      passHeader: {
        marginTop: "1em"
      },
      delete: {
        textDecoration: "underline",
        cursor: "pointer"
      },
      labelSizeInputsContainer: {
        marginTop: -15
      },
      labelSizeTextfield: {
        width: 24
      },
      labelSizeCross: {
        margin: "0 5px"
      },
      labelSizeUnits: {
        marginLeft: 5
      },
      anotherSizeNote: {
        marginTop: 5,
        fontSize: "0.9em",
        fontStyle: "italic"
      }
    };
  }

  _makeCustomLabelOption(value) {
    // Unprefix if prefixed for display purposes
    if (value.startsWith(CUSTOM_TEXT_PREFIX)) {
      value = value.slice(CUSTOM_TEXT_PREFIX.length);
    }

    return {
      label: `Custom text: "${value}"`,
      value: `${CUSTOM_TEXT_PREFIX}${value}`
    };
  }

  render() {
    let styles = this.getStyles()
    let bucket = EventBucketStore.getEventBucketById(this.props.params.eventBucketId)
    let allPassBuckets = this.state.isMembership ? PassBucketStore.getMembershipsForEventBucket(this.props.params.eventBucketId) : PassBucketStore.getPassBucketsForEventBucket(this.props.params.eventBucketId)
    const items = this.state.isMembership ? this.state.selectedMemberships : this.state.selectedPassBuckets
    const showItems = items && items.length > 0

    if (!this.state.hasInjectedSavedSettings) {
      return <WorkingIndicator fullPage={true} />;
    }

    const singular = this.state.isMembership ? "membership" : "pass"
    const plural = this.state.isMembership ? "memberships" : "passes"
    const capitalize = str => str.substring(0, 1).toLocaleUpperCase() + str.substring(1)

    return (
      <div>
        <Dialog
          title={`${capitalize(singular)} label printer`}
          actions={[
            <FlatButton
              label={this.state.completedPrint ? "Close" : "Cancel"}
              onTouchTap={this.closePrint}
            />
          ]}
          autoDetectWindowHeight={false}
          autoScrollBodyContent={false}
          bodyStyle={{ overflowY: "visible" }}
          open={this.state.printing || this.state.showPrintSuccess}
        >
          <div>
            {this.state.printing ? (
              <div>
                <WorkingIndicator centered={true} />
                <div style={{ marginTop: "1em", textAlign: "center" }}>
                  Your {plural} are being generated!
                  <br />
                  They will automatically open as soon as they are ready for
                  printing.
                </div>
              </div>
            ) : this.state.completedPrint ? (
              this.state.completedPrint.error ? (
                <div>
                  <div>
                    Unfortunately, we ran into an error printing your {plural}.
                    <br />
                    Please try again, or contact us if the problem persists.
                  </div>
                  <div style={{ marginTop: "1em" }}>
                    <i>
                      Error: <strong>{this.state.completedPrint.error}</strong>
                    </i>
                  </div>
                </div>
              ) : (
                <div>
                  Your {plural} should have begun downloading. If they did not,{" "}
                  <a
                    target="_blank"
                    href={this.state.completedPrint.download_url}
                  >
                    click here to download
                  </a>
                  .
                </div>
              )
            ) : null}
          </div>
        </Dialog>

        <h1>{capitalize(singular)} label printer</h1>
        <InfoNotice style={{ marginTop: 20 }}>
          Check out our{" "}
          <a
            href="https://help.eventive.org/en/articles/914882-print-pass-and-membership-labels"
            target="_blank"
          >
            guide to printing {singular} labels
          </a>
          .
        </InfoNotice>
        <p>
          Use this wizard to print labels for your {plural}. The settings you choose here are automatically saved for future printings.
        </p>
        {this.state.selectedPasses ? (
          <div style={styles.selectedPass}>
            <div>
              Selected {this.state.selectedPasses.length > 0 ? `${plural}` : `${singular}`}
              <strong>
                {this.state.selectedPasses.map(p => p.name).join(", ")}
              </strong>
            </div>
            {this.state.settings.label_type === "sheet" ? (
              <div>
                Labels to skip:
                <QuantityEditor
                  style={{ display: "inline-block" }}
                  min={0}
                  quantity={this.state.skip}
                  updateQuantity={q => this.setState({ skip: q })}
                />
              </div>
            ) : null}
            <div>
              <LinkLike
                onTouchTap={() => this.setState({ selectedPasses: null })}
              >
                Reset
              </LinkLike>
            </div>
          </div>
        ) : (
          <div>
            <div>
              <InjectedSelect
                value={items.map(b => b.id)}
                types={this.state.isMembership ? ["memberships"] : ["pass_buckets"]}
                skipFetch={true}
                label={`${this.state.isMembership ? "Memberships" : "Pass buckets"} to print`}
                multi={true}
                labelFormatter={b => b.name}
                eventBucketId={this.props.params.eventBucketId}
                changeValueFunction={o => o}
                onChange={selected => this.setPassBuckets(selected)}
              />
            </div>
            <div style={{ marginTop: 8 }}>
              <Checkbox
                label={`Print all ${this.state.isMembership ? "memberships" : "pass buckets"}`}
                checked={items.length === allPassBuckets.length}
                onCheck={(e, checked) =>
                  this.setPassBuckets(checked ? allPassBuckets : [])
                }
              />
            </div>
          </div>
        )}
        {showItems ? (
          <div>
            {this.state.settings.label_type !== "sundance" ? (
              <div>
                <h2 style={styles.h2}>{this.state.isMembership ? "Membership" : "Pass bucket"} setup</h2>
                {items.map(b => {
                  let config = this.state.passBucketConfiguration[b.id],
                    allOptions = DEFAULT_FIELDS.concat(
                      (b.supplementary_data || []).map(d => {
                        return { value: d.key, label: d.label, type: d.type };
                      })
                    ),
                    availableImages = allOptions.filter(
                      o => o.type === "image"
                    ),
                    options = allOptions.filter(o => o.type !== "image");

                  return (
                    <div key={b.id}>
                      <h3 style={styles.passHeader}>
                        "{b.name}" label configuration (
                        <LinkLike
                          onTouchTap={() => {
                            let shownConfigs = Object.assign(
                              this.state.shownConfigs,
                              { [b.id]: !this.state.shownConfigs[b.id] }
                            );
                            this.setState({ shownConfigs });
                          }}
                        >
                          {this.state.shownConfigs[b.id] ? "hide" : "show"}
                        </LinkLike>
                        )
                      </h3>
                      {this.state.shownConfigs[b.id] ? (
                        <div>
                          {config.rows.map((r, i) => {
                            let rowOptions = options.concat(
                              (r.fields || [])
                                .filter(f => f.startsWith(CUSTOM_TEXT_PREFIX))
                                .map(v => this._makeCustomLabelOption(v))
                            );

                            return (
                              <div>
                                <Label>
                                  Row {i + 1}{" "}
                                  {i !== 0 && (
                                    <span
                                      style={styles.delete}
                                      onClick={() => {
                                        config.rows.splice(i, 1);
                                        this.updateConfig(b.id, config);
                                      }}
                                    >
                                      [delete]
                                    </span>
                                  )}
                                </Label>
                                <Creatable
                                  autosize={true}
                                  multi={true}
                                  placeholder={
                                    "Select fields to print, or type for custom text (If you select multiple fields, the first one that is not empty will be printed.)"
                                  }
                                  promptTextCreator={label => label}
                                  newOptionCreator={({
                                    label,
                                    labelKey,
                                    valueKey
                                  }) => {
                                    return this._makeCustomLabelOption(label);
                                  }}
                                  value={r.fields || []}
                                  options={rowOptions}
                                  isOptionUnique={() => true}
                                  shouldKeyDownEventCreateNewOption={({
                                    keyCode
                                  }) => {
                                    switch (keyCode) {
                                      case 9: // TAB
                                      case 13: // ENTER
                                        return true;
                                    }
                                    return false;
                                  }}
                                  onChange={selected => {
                                    r.fields = selected.map(s => s.value);
                                    this.updateConfig(b.id, config);
                                  }}
                                />
                              </div>
                            );
                          })}
                          {config.image ? (
                            <SelectField
                              label="Image to print"
                              options={availableImages}
                              placeholder="Select an image field to print"
                              value={config.image}
                              onChange={selected => {
                                config.image = selected ? selected.value : null;
                                this.updateConfig(b.id, config);
                              }}
                            />
                          ) : null}
                          <div style={{ marginTop: "1em" }}>
                            <RaisedButton
                              label="Add row"
                              onClick={() => {
                                config.rows.push({});
                                this.updateConfig(b.id, config);
                              }}
                            />
                            {!config.image && availableImages.length ? (
                              <RaisedButton
                                style={{ marginLeft: 7 }}
                                label="Add image"
                                onClick={() => {
                                  config.image = availableImages[0].value;
                                  this.updateConfig(b.id, config);
                                }}
                              />
                            ) : null}
                          </div>
                        </div>
                      ) : null}
                    </div>
                  );
                })}
              </div>
            ) : null}
            <h2 style={styles.h2}>Label setup</h2>
            <Label>Label type</Label>
            <RadioButtonGroup
              name="label_type"
              valueSelected={this.state.settings.label_type}
              style={{ maxWidth: 500 }}
              onChange={(e, v) => this.updateSetting("label_type", v)}
            >
              <RadioButton
                value="individual"
                label={
                  <span>
                    <strong>Individual</strong>: For use with a dedicated label
                    printer.
                  </span>
                }
              />
              <RadioButton
                value="sheet"
                label={
                  <span>
                    <strong>Sheet</strong>: For printing via a standard printer.
                  </span>
                }
              />
              <RadioButton
                value="individual_padded"
                label={
                  <span>
                    <strong>Individual padded</strong>: For printing via any
                    printer, with labels taking up only some of the page (e.g.
                    to print labels on pre-printed {plural}).
                  </span>
                }
              />
              <RadioButton
                value="sundance"
                label={
                  <span>
                    <strong>Sundance</strong>: For printing the full page
                    Sundance label on a standard 8.5" x 11" page in landscape
                    format.
                  </span>
                }
                style={{
                  display: bucket.frontend_config.sundance_login
                    ? "block"
                    : "none"
                }}
              />
            </RadioButtonGroup>
            {this.state.settings.label_type === "individual_padded" ? (
              <div>
                <Label>Page size</Label>
                <div style={styles.labelSizeInputsContainer}>
                  <TextField
                    style={styles.labelSizeTextfield}
                    name="width"
                    placeholder="W"
                    onChange={e =>
                      this.updateSetting(
                        "individual_page_width",
                        e.target.value
                      )
                    }
                    value={this.state.settings.individual_page_width}
                  />
                  <span style={styles.labelSizeCross}>×</span>
                  <TextField
                    style={styles.labelSizeTextfield}
                    name="height"
                    placeholder="H"
                    onChange={e =>
                      this.updateSetting(
                        "individual_page_height",
                        e.target.value
                      )
                    }
                    value={this.state.settings.individual_page_height}
                  />
                  <span style={styles.labelSizeUnits}>inches</span>
                </div>
                <Label>Page margin</Label>
                <div style={styles.labelSizeInputsContainer}>
                  <span style={{ marginRight: 5 }}>Top</span>
                  <TextField
                    style={styles.labelSizeTextfield}
                    name="width"
                    placeholder="T"
                    onChange={e =>
                      this.updateSetting(
                        "individual_top_margin",
                        e.target.value
                      )
                    }
                    value={this.state.settings.individual_top_margin}
                  />
                  <span style={styles.labelSizeCross}>× Left</span>
                  <TextField
                    style={styles.labelSizeTextfield}
                    name="height"
                    placeholder="L"
                    onChange={e =>
                      this.updateSetting(
                        "individual_left_margin",
                        e.target.value
                      )
                    }
                    value={this.state.settings.individual_left_margin}
                  />
                  <span style={styles.labelSizeUnits}>inches</span>
                </div>
              </div>
            ) : null}
            {this.state.settings.label_type === "individual" ||
              this.state.settings.label_type === "individual_padded" ? (
              <div>
                <Label>Label size</Label>
                <div style={styles.labelSizeInputsContainer}>
                  <TextField
                    style={styles.labelSizeTextfield}
                    name="width"
                    placeholder="W"
                    onChange={e =>
                      this.updateSetting(
                        "individual_label_width",
                        e.target.value
                      )
                    }
                    value={this.state.settings.individual_label_width}
                  />
                  <span style={styles.labelSizeCross}>×</span>
                  <TextField
                    style={styles.labelSizeTextfield}
                    name="height"
                    placeholder="H"
                    onChange={e =>
                      this.updateSetting(
                        "individual_label_height",
                        e.target.value
                      )
                    }
                    value={this.state.settings.individual_label_height}
                  />
                  <span style={styles.labelSizeUnits}>inches</span>
                </div>
              </div>
            ) : null}
            {this.state.settings.label_type === "sheet" ? (
              <div>
                <Label>Sheet format</Label>
                <RadioButtonGroup
                  name="sheet_label_format"
                  valueSelected={this.state.settings.sheet_label_format}
                  onChange={(e, v) =>
                    this.updateSetting("sheet_label_format", v)
                  }
                >
                  <RadioButton value="avery5160" label={"Avery 5160/5260: 1\" x 2-5/8\" (30 per sheet)"} />
                  <RadioButton value="avery5360" label={"Avery 5360: 1-1/2\" x 2-13/16\" (21 per sheet)"} />
                  <RadioButton value="avery5390" label={"Avery 5390: 2-1/4\" x 3-1/3\" (8 per sheet)"} />
                  <RadioButton value="avery5395" label={"Avery 5395: 2-1/3\" x 3-3/8\" (8 per sheet)"} />
                  <RadioButton value="avery5161" label={"Avery 5161: 1\" x 4\" (20 per sheet)"} />
                  <RadioButton value="avery5162" label={"Avery 5162: 1-1/3\" x 4\" (14 per sheet)"} />
                  <RadioButton value="avery5163" label={"Avery 5163: 2\" x 4\" (10 per sheet)"} />
                  <RadioButton value="averyL7120" label={"Avery L7120-25: 35mm x 35mm (35 per sheet)"} />
                  <RadioButton value="avery94220" label={"Avery 94220: 1\" x 2\" (24 per sheet)"} />
                </RadioButtonGroup>
                <div style={styles.anotherSizeNote}>
                  Looking for another size?{" "}
                  <LinkLike
                    onTouchTap={() =>
                      Intercom("showNewMessage", "New requested label format: ")
                    }
                  >
                    Just ask!
                  </LinkLike>
                </div>
              </div>
            ) : null}
            {!this.state.selectedPasses ? (
              <div>
                <Label>Sorting</Label>
                {this.state.settings.label_type !== "sundance" ? (
                  <Checkbox
                    label="Sort labels by second row on label (e.g. to group by supplementary data)"
                    checked={this.state.settings.sort_by_row_2}
                    onCheck={(e, checked) =>
                      this.updateSetting("sort_by_row_2", checked)
                    }
                  />
                ) : null}
                <Checkbox
                  label={
                    this.state.settings.sort_by_row_2
                      ? "After sorting by second row, sort labels by last name"
                      : "Sort labels by last name"
                  }
                  checked={this.state.settings.sort_by_last_name}
                  onCheck={(e, checked) =>
                    this.updateSetting("sort_by_last_name", checked)
                  }
                />
              </div>
            ) : null}
            {this.state.settings.label_type !== "sundance" ? (
              <div>
                <Label>Additional options</Label>
                {this.state.settings.label_type !== "sheet" ? (
                  <Checkbox
                    label={
                      <span>
                        Duplex printing (i.e. print two copies of each {singular}, for front & back printing)
                      </span>
                    }
                    checked={this.state.settings.duplex}
                    onCheck={(e, checked) =>
                      this.updateSetting("duplex", checked)
                    }
                  />
                ) : null}
                <Checkbox
                  label={
                    <span>
                      <em>Not recommended:</em> Hide QR code on printed {singular} (scanning will no longer be possible!)
                    </span>
                  }
                  checked={this.state.settings.omit_qr_code}
                  onCheck={(e, checked) =>
                    this.updateSetting("omit_qr_code", checked)
                  }
                />
                {Object.entries(this.state.passBucketConfiguration).some(
                  ([k, c]) =>
                    items.some(b => b.id === k) !==
                    -1 && c.image
                ) ? (
                  <div>
                    <Checkbox
                      label={
                        <span>
                          Filter by image: only print {plural} that have an image specified
                        </span>
                      }
                      checked={this.state.settings.filter_by_image}
                      onCheck={(e, checked) =>
                        this.updateSetting("filter_by_image", checked)
                      }
                    />
                    <Checkbox
                      label={
                        <span>
                          Place image next to QR code beneath main text
                        </span>
                      }
                      checked={this.state.settings.image_qr_code_alt_display}
                      onCheck={(e, checked) =>
                        this.updateSetting("image_qr_code_alt_display", checked)
                      }
                    />
                  </div>
                ) : null}
                <Checkbox
                  label={<span>Use a custom font for label text</span>}
                  checked={
                    this.state.customFont ||
                    this.state.settings.font_family !== "Open Sans"
                  }
                  onCheck={(e, checked) =>
                    checked
                      ? this.setState({ customFont: true })
                      : this.setState({ customFont: false }, () =>
                        this.updateSetting("font_family", "Open Sans")
                      )
                  }
                />
                {this.state.customFont ||
                  this.state.settings.font_family !== "Open Sans" ? (
                  <div style={{ marginLeft: "3em", marginTop: 3 }}>
                    <RadioButtonGroup
                      name="font_famly"
                      valueSelected={this.state.settings.font_family}
                      onChange={(e, v) => this.updateSetting("font_family", v)}
                    >
                      <RadioButton
                        value="Open Sans"
                        label={"Open Sans (default)"}
                      />
                      <RadioButton
                        value="Gotham Narrow"
                        label={"Gotham Narrow"}
                      />
                      <RadioButton
                        value="Trixie-Plain"
                        label={"Trixie Plain"}
                      />
                      <RadioButton
                        value="Armin Grotesk"
                        label={"Armin Grotesk"}
                      />
                      <RadioButton value="borneo" label="Borneo" />
                    </RadioButtonGroup>
                    <div
                      style={Object.assign({}, styles.anotherSizeNote, {
                        marginBottom: 5
                      })}
                    >
                      Looking for a different custom font?{" "}
                      <LinkLike
                        onTouchTap={() =>
                          Intercom(
                            "showNewMessage",
                            "Requested custom label font: "
                          )
                        }
                      >
                        Let us know!
                      </LinkLike>
                    </div>
                  </div>
                ) : null}
                {this.state.settings.label_type !== "sheet" ? (
                  <div>
                    <Checkbox
                      label={<span>Adjust label text size</span>}
                      checked={
                        this.state.customFontSize ||
                        this.state.settings.font_scale_factor !== 1
                      }
                      onCheck={(e, checked) =>
                        checked
                          ? this.setState({ customFontSize: true })
                          : this.setState({ customFontSize: false }, () =>
                            this.updateSetting("font_scale_factor", 1)
                          )
                      }
                    />
                    {this.state.customFontSize ||
                      this.state.settings.font_scale_factor !== 1 ? (
                      <div style={{ marginLeft: "3em", marginTop: 3 }}>
                        <RadioButtonGroup
                          name="font_scale_factor"
                          valueSelected={this.state.settings.font_scale_factor}
                          onChange={(e, v) =>
                            this.updateSetting("font_scale_factor", v)
                          }
                        >
                          <RadioButton value={0.95} label={"Smaller"} />
                          <RadioButton value={1} label={"Default"} />
                          <RadioButton value={1.05} label={"Larger"} />
                          <RadioButton value={1.1} label={"Even larger"} />
                        </RadioButtonGroup>
                      </div>
                    ) : null}
                  </div>
                ) : null}
              </div>
            ) : null}
            {!this.state.selectedPasses ? (
              <div>
                <h2 style={{ margin: "0.75em 0 0.5em" }}>Print range</h2>
                <RadioButtonGroup
                  name="print_range"
                  valueSelected={
                    this.state.printAllTime ? "all_time" : "interval"
                  }
                  onChange={(e, v) =>
                    this.setState({ printAllTime: v === "all_time" })
                  }
                >
                  <RadioButton
                    value="all_time"
                    label={
                      <span>
                        <strong>All time</strong>: Print all {plural}.
                      </span>
                    }
                  />
                  <RadioButton
                    value="interval"
                    label={
                      <span>
                        <strong>Time interval</strong>: Print only {plural} updated within a specified interval.
                      </span>
                    }
                  />
                </RadioButtonGroup>
                {!this.state.printAllTime ? (
                  <div>
                    <DateTimeField
                      name="startTime"
                      label={`${capitalize(plural)} must have been updated after`}
                      value={this.state.startTime}
                      onChange={(_, startTime) => this.setState({ startTime })}
                    />
                    <DateTimeField
                      name="endTime"
                      label={`${capitalize(plural)} must have been updated before`}
                      placeholder="Right now"
                      value={this.state.endTime}
                      onChange={(_, endTime) => this.setState({ endTime })}
                    />
                  </div>
                ) : null}
              </div>
            ) : null}
            <RaisedButton
              primary={true}
              style={{ marginTop: "1em" }}
              label={
                this.state.selectedPasses &&
                  this.state.selectedPasses.length === 1
                  ? `Print ${singular}`
                  : `Print ${plural}`
              }
              onTouchTap={this.print}
            />
          </div>
        ) : null}
      </div>
    );
  }
}

export default connectToStores(PassLabelPrinter);



// WEBPACK FOOTER //
// ./src/app/components/pass-label-printer.jsx